import { environment } from '../../environments/environment';

export const getInlineIframeStyle = () => {
  return environment.iframe.style
    .replace('position: fixed;', 'position:relative;')
    .replace('background-color: #00000038', 'background-color: #F5F7FA');
};
